// Reemplaza el puntero del mouse por el sol de Beni's — solo en computadores
// con mouse real (nunca en celular/tablet, nunca si el usuario pidió menos
// animaciones). Un script independiente, mismo patrón que el resto del theme
// (detail-scroll.js, brand-origin-scroll.js, etc.) — no depende de nada más
// y no rompe nada si falla: si este script no corre, el navegador simplemente
// se queda con el cursor normal (nunca se oculta el cursor nativo por CSS a
// ciegas; solo lo oculta esta misma clase que agrega el script una vez que ya
// está listo para reemplazarlo).
(function () {
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!canHover || reducedMotion) return;

  var cursor = document.createElement('div');
  cursor.className = 'sun-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  cursor.innerHTML = '<span class="sun-cursor__glyph"></span>';
  document.body.appendChild(cursor);
  document.documentElement.classList.add('has-sun-cursor');

  var x = 0;
  var y = 0;
  var visible = false;
  var raf = null;
  var lastContrastCheck = 0;

  // El sol es amarillo (--yellow, #FFC331) siempre — es el color principal
  // de la marca. Solo cambia a café oscuro (--brown-dark) cuando el fondo
  // real de abajo es amarillo o muy parecido y el amarillo se perdería ahí
  // (la barra de anuncios, bloques CTA amarillos, etc.). Sobre fondos claros
  // (crema, blanco) o realmente oscuros (café) el amarillo ya se ve bien
  // solo — ahí no hace falta ni conviene tocarlo.
  var YELLOW_LUMINANCE = 0.773; // luminancia relativa de #FFC331
  var LOW_CONTRAST_DELTA = 0.15; // qué tan cerca de ese amarillo cuenta como "se pierde"

  // Sube por los padres desde el punto del cursor hasta encontrar un
  // background-color declarado (los transparentes no cuentan) y devuelve su
  // luminancia relativa. Si nadie lo declaró, devuelve null (no se sabe).
  function backgroundLuminanceAt(px, py) {
    var el = document.elementFromPoint(px, py);
    while (el && el !== document.documentElement) {
      var bg = getComputedStyle(el).backgroundColor;
      var match = bg && bg.match(/rgba?\(([^)]+)\)/);
      if (match) {
        var parts = match[1].split(',').map(function (n) { return parseFloat(n); });
        var alpha = parts.length > 3 ? parts[3] : 1;
        if (alpha > 0.4) {
          return (0.2126 * parts[0] + 0.7152 * parts[1] + 0.0722 * parts[2]) / 255;
        }
      }
      el = el.parentElement;
    }
    return null;
  }

  function render() {
    cursor.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    // El sampling de color es más caro que solo mover el div — alcanza con
    // chequearlo unas ~12 veces por segundo, no en cada frame.
    var now = performance.now();
    if (now - lastContrastCheck > 80) {
      lastContrastCheck = now;
      var luminance = backgroundLuminanceAt(x, y);
      var lowContrast = luminance !== null && Math.abs(luminance - YELLOW_LUMINANCE) < LOW_CONTRAST_DELTA;
      cursor.classList.toggle('is-low-contrast', lowContrast);
    }
    raf = null;
  }

  function onMove(event) {
    x = event.clientX;
    y = event.clientY;
    if (!visible) {
      visible = true;
      cursor.classList.add('is-visible');
    }
    if (!raf) raf = requestAnimationFrame(render);
  }

  function onLeave() {
    visible = false;
    cursor.classList.remove('is-visible');
  }

  var interactiveSelector =
    'a, button, [role="button"], input, textarea, select, label, ' +
    '[data-atc], [data-cart-open], [data-cart-close], [data-pickup-open], ' +
    '.instagram-tile, .cart-upsell-card__button, summary';
  var textInputSelector = 'input, textarea, [contenteditable="true"]';

  function onOver(event) {
    var target = event.target.closest ? event.target.closest(interactiveSelector) : null;
    if (!target) return;
    cursor.classList.toggle('is-active', !target.closest(textInputSelector));
    cursor.classList.toggle('is-text', !!target.closest(textInputSelector));
  }

  function onOut(event) {
    var related = event.relatedTarget;
    var stillInside = related && related.closest && related.closest(interactiveSelector);
    if (!stillInside) {
      cursor.classList.remove('is-active', 'is-text');
    }
  }

  document.addEventListener('mousemove', onMove, { passive: true });
  document.addEventListener('mouseover', onOver, { passive: true });
  document.addEventListener('mouseout', onOut, { passive: true });
  document.addEventListener('mouseleave', onLeave);
  window.addEventListener('blur', onLeave);

  // Los <dialog> abiertos con showModal() (carrito, buscador, retiro en
  // tienda, este popup) viven en la "capa superior" del navegador — quedan
  // arriba de TODO lo demás sin importar z-index, así que nuestro cursor de
  // mentira (un div normal) siempre terminaría tapado detrás. La única
  // solución real es pausarlo del todo (devolver el cursor nativo) mientras
  // haya un modal abierto, y reactivarlo cuando se cierra. Un
  // MutationObserver sobre el atributo "open" cubre todos los modales
  // actuales y los que se agreguen después, sin tener que tocar este script
  // de nuevo.
  function syncWithDialogs() {
    var blocked = !!document.querySelector('dialog[open]');
    document.documentElement.classList.toggle('has-sun-cursor-paused', blocked);
  }

  var dialogObserver = new MutationObserver(syncWithDialogs);
  dialogObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  });
  syncWithDialogs();
})();
